import React from 'react';
import { Trans } from 'react-i18next';
import { Link, Text } from '@nimbus-ds/components';
import { RenderByCountry } from 'commons/components';
import { useTranslationWithPrefix } from 'commons/utils';

const UploadDocumentationLink = () => {
  const { t } = useTranslationWithPrefix('home.chargebackAlerts.pending');

  return (
    <RenderByCountry
      MX={
        <Text>
          <Trans
            t={t}
            i18nKey="uploadDocumentation"
            components={{
              shipping: (
                <Link
                  key="shipping-doc"
                  as="a"
                  href={t('shippingDocumentationUrl')}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={t('shippingDocumentationAriaLabel')}
                  data-testid="shipping-documentation-link"
                >
                  {''}
                </Link>
              ),
              sale: (
                <Link
                  key="sales-doc"
                  as="a"
                  href={t('salesDocumentationUrl')}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={t('salesDocumentationAriaLabel')}
                  data-testid="sales-documentation-link"
                >
                  {''}
                </Link>
              ),
            }}
          />
        </Text>
      }
      AR={
        <Link
          as="a"
          href={t('documentationUrl')}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={t('documentationAriaLabel')}
          data-testid="documentation-link"
        >
          {t('uploadDocumentation')}
        </Link>
      }
    />
  );
};

export default UploadDocumentationLink;
